import * as React from "react"
import "./header.scss";
import { Link as Scroll, scroller } from 'react-scroll';
import { NAVIGATION_LINKS, CONTACT_LINK } from "~/const";

import IconMail from "~/assets/icon/icon_mail.svg";
import IconDocument from "~/assets/icon/icon_document.svg";

export const Header = () => {

    const [pathname, setPathname] = React.useState("");
    const downloadLink = "/download";
    const menuCheckbox = React.createRef<HTMLInputElement>();

    React.useEffect(() => setPathname(window.location.pathname));

    const clickToScroll = (e) => {
        scroller.scrollTo(e.target.hash.replace("#", ""), {
            smooth: true
        });
        if(menuCheckbox.current){
            menuCheckbox.current.checked = false;
        }
    }

    return (
        <div className="header__wrapper">
            <header>
                <div className="header__content">
                    <h1><a href="/">
                            <img className="header__logo" src="/images/logo/text_logo.svg" alt="（株）Sally127 | 通販の失敗/返品をなくす アプリのいらないバーチャル試着" height="30" width="145" />
                        </a>
                    </h1>
                    <nav className="header__navPc">
                        {
                            NAVIGATION_LINKS.map((item, i) => (
                                (pathname === "/" && item.link.search(/\#.*/g) >= 0)
                                    ? <Scroll href="/" key={i} smooth={true} to={item.link.replace("#", "")} className="header__navItem">{item.label}</Scroll>
                                    : <a key={i} href={ `${item.link.search(/\#.*/) >= 0 ? "/" : ""}${item.link}` } className="header__navItem">{item.label}</a>
                            ))
                        }
                        <a href={downloadLink} className="header__contactLink" onClick={() => gtag('event', 'click', {'event_category': 'cv_button','event_label': 'downloadButton_on_header'})}>
                            <IconDocument />
                            <span>資料請求</span>
                        </a>
                        <a href={CONTACT_LINK} className="header__contactLink" onClick={() => gtag('event', 'click', {'event_category': 'cv_button','event_label': 'contact_on_header'})}>
                            <IconMail />
                            <span>お問い合わせ</span>
                        </a>
                    </nav>

                    <nav className="header__navSp">
                        <input id="header__navSp_checkbox" className="header__navSp_checkbox" type="checkbox" ref={menuCheckbox}/>
                        <label htmlFor="header__navSp_checkbox" className="header__navSp_checkboxLabel">
                            <span className="header__navSp_iconWrapper">
                                <span className="header__navSp_iconParent">
                                    <span className="header__navSp_iconChild header__navSp_iconChild--first"></span>
                                    <span className="header__navSp_iconChild header__navSp_iconChild--second"></span>
                                    <span className="header__navSp_iconChild header__navSp_iconChild--third"></span>
                                </span>
                            </span>
                        </label>

                        <div className="header__navSp_content">
                            {
                                NAVIGATION_LINKS.map((item, i) => (
                                (pathname === "/" && item.link.search(/\#.*/g) >= 0)
                                    ? <a key={i} onClick={clickToScroll}  href={ `${item.link.search(/\#.*/) >= 0 ? "/" : ""}${item.link}` } className="header__navSp_item">{item.label}</a>
                                    : <a key={i} href={ `${item.link.search(/\#.*/) >= 0 ? "/" : ""}${item.link}` } className="header__navSp_item">{item.label}</a>
                            ))
                            }
                            <div  className="header__navSp_contactLinkArea">
                                <a href={downloadLink} className="header__navSp_contactLink">
                                    <IconDocument />
                                    <span>資料請求</span>
                                </a>
                                <a href={CONTACT_LINK} className="header__navSp_contactLink">
                                    <IconMail />
                                    <span>お問合せ</span>
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        </div>
    );
}
